// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");

function FaIcon(Props) {
  var classes = Props.classes;
  return React.createElement("span", {
              key: classes
            }, React.createElement("i", {
                  className: classes
                }));
}

var make = FaIcon;

exports.make = make;
/* react Not a pure module */
